export default "__VITE_ASSET__b75aa5f4__"